import axios from 'axios'

class ApiService {
  constructor() {
    this.baseUrl = `${document.body.dataset.apiUrl}/`
  }

  service = () => {
    // service.interceptors.response.use(
    //   (response) => this.handleSuccess(response),
    //   (error) => this.handleError(error),
    // )

    return axios.create({
      headers: {
        token: localStorage.token,
        cartToken: localStorage.cart_token,
        csrf: 'token',
      },
    })
  }

  handleSuccess = (response) => {
    return response
  }

  handleError(error) {
    switch (error.response.status) {
      case 404:
        console.log('Error 404')
        this.redirectTo(document, '/404')
        break
      case 422:
        console.log('Error 422')
        break
      case 500:
        console.log('Error 500')
        this.redirectTo(document, '/500')
        break
      default:
      // do nothing
    }
    return Promise.reject(error)
  }

  redirectTo = (document, path) => {
    document.location = path
  }

  get(resource) {
    return this.service().get(this.baseUrl + resource)
  }

  post(resource, payload) {
    return this.service().request({
      method: 'POST',
      url: this.baseUrl + resource,
      responseType: 'json',
      data: payload,
    })
  }

  put(resource, payload) {
    return this.service().request({
      method: 'PUT',
      url: this.baseUrl + resource,
      responseType: 'json',
      data: payload,
    })
  }

  delete(resource) {
    return this.service().request({
      method: 'DELETE',
      url: this.baseUrl + resource,
      responseType: 'json',
    })
  }
}

export default new ApiService()
